import { HttpClient, RequestParams } from './http-client';

export class MetricTest<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  metricTest = (params: RequestParams = {}) =>
    this.request<unknown, any>({
      path: `/metric-test`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
